import { Component } from 'react';
import { toast } from 'react-toastify';

class TextUtils extends Component {

    // constructor(props) {
    //     super(props);
    // }
    isEmpty = (val, fieldName, errorFlag) => {// errorFlag = whether to show error show or not.! 
        if (val === null || val === undefined || val === "" || val === 0) {
            if (errorFlag) {
                toast.error(`${fieldName} must not be Empty.`)
            }
            return true;
        }
        return false;
    }

    isNumeric = (str, fieldName, errorFlag, size) => {
        if (typeof str === "number") {
            return true;
        }
        if (typeof str != "string") {
            return false; // we only process strings!  
        }
        if (!(!isNaN(str) && !isNaN(parseFloat(str)))) {
            if (errorFlag) {
                toast.error(`${fieldName} must not be numeric`)
            }
        } else if (size && !((str.length >= size?.min) && (str.length <= size?.max))) {
            toast.error(`${fieldName} Size must be between ${size?.min} to ${size?.max}`)

        } else {
            return !isNaN(str) && // use type coercion to parse the entirety of the string (`parseFloat` alone does not do this)...
                !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
        }
    }

    isValidIpAddressTest = (val, fieldName, errorFlag) => {
        let IpRegex = /^(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        if (errorFlag) {
            if (IpRegex.test(val)) {
                return false
            } else {
                toast.error(`Enter Valid ${fieldName}.`)
                return true;
            }
        }
        return true;
    }
}

export default new TextUtils();